import React from "react";
import MUIDataTable from "mui-datatables";
import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

import axios from 'axios';
import Fab from '@material-ui/core/Fab';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ViewIcon from '@material-ui/icons/Visibility';
import { Container, Row, Col } from "shards-react";
import CircularProgress from '@material-ui/core/CircularProgress';
import CustomToolbar from "../../common/AddButton";

import Button from '@material-ui/core/Button';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
  //import { Store } from "../../flux";
import  api from '../../common/api';
import Backdrop from '@material-ui/core/Backdrop';
import Typography from '@material-ui/core/Backdrop';

class Models extends React.Component {

   constructor() {
      super();

      this.state = {
        data: '',
        isLoaded: false,
        backdrop:false,
        models:[]
      }
      this.handleDelete = this.handleDelete.bind(this)
  }

    async componentDidMount() {
      var params = this.getParams()
      var brand_id = (params.brand_id)? params.brand_id : 0
      await this.getModels(brand_id);
      this.setState({brand_id})
    }
   
    getParams(){
      return this.props.match.params
    }

   getModels(brand_id){
     const token =localStorage.getItem('userToken')
     return axios
              .get(api.versions().index(brand_id),{ headers: {"Authorization" : `Bearer ${token}`} })
              .then(res => {
                this.setState({isLoaded: true, models: res.data})
              })
              .catch(err =>{
                this.setState({isLoaded: true, models: [] })
              })
  }

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
         root: {
           padding: '0px 8px 0px 8px',
           fontSize: '0.73rem'
          }
        }
      }
  });      

  handleDialogClose(e){
    e.preventDefault();
    this.setState({dialogOpen: false, errors: false, message: '', delete_id: ''})
  }

  handleRefresh(e){
    e.preventDefault();
    this.setState({isLoaded: false, models:[]})
    var params = this.getParams()
    var brand_id = (params.brand_id)? params.brand_id : 0
    this.getModels(brand_id);
    this.handleDialogClose(e)
 }



  handleDelete(e, id){
    e.preventDefault();
    var model = ''
    this.state.models.map((val, idx)=>{
        if(val.id === id){
          model = val.name
          this.setState({delete_id: val.id})
        }
    })

    var message = ''
    if (model !==''){
        message = 'Está a punto de dar de baja el modelo '+ model +'. ¿Está seguro?'
    } else {
        message = 'Hubo un problema al dar de baja al vehiculo.'
    }
    this.setState({message: message, dialogOpen: true })
  }

  confirmDelete() {
    const token = localStorage.getItem('userToken')
    return axios
     .delete(api.models().delete(this.state.delete_id),
     {params: {'version[id]':this.state.delete_id }, headers: {"Authorization" : `Bearer ${token}`} }
      )

    .then(res => {
          this.setState({message: 'Modelo dado de baja con éxito!'})
          this.setState({errors: false})
          this.setState({delete_id: ''})
      })
      .catch(err =>{
          this.setState({errors: true})
          this.setState({delete_id: ''})
          this.setState({message: err.response.data.errors["id"]})
      })

  }

  handleDownload = () => {
      var formData = new FormData();
      var brand_id = (this.state.brand_id)  ? this.state.brand_id : 0
      const token = localStorage.getItem('userToken')
      axios.post(api.models().export(brand_id),
        formData,
        {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
         )
        .then((response)=> {
            this.handleCloseBackdrop()
            window.location.href = response.data
        })
        .catch(error => {
            alert('Falló la descarga')
      })

  }

  handleCloseBackdrop = () => {
    var backdrop = !this.state.backdrop
    this.setState({backdrop: backdrop})
  }

  render(){
     const columns = [
     {
      name: "variation.id",
      label: "Id Modelo",
      options: {
       filter: false,
       sort: true,
      }
     },
     {
      name: "variation.brand.name",
      label: "Marca",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     },
     {
      name: "variation.dnrpa_description",
      label: "Modelo",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     },
     {
      name: "name",
      label: "Version",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     },
     {
      name: "id",
      label: "ID Version",
      options: {
       filter: false,
       display: false,
      }
     },{
        name: "Acciones",
        label: "",
        options: {
            filter: false,
            setCellHeaderProps: () => ({ align: 'center' }),
            customBodyRender: (value, tableMeta, updateValue) => {
              const rowId = tableMeta.rowData[0]
              const version_id = tableMeta.rowData[4]
              //const rowId = 1
              return (
                <div className="row" style={{display: 'block'}}>
                  <Fab color="primary" aria-label="view"  variant="extended" style={{boxShadow: 'none', backgroundColor: "green" }} fontSize="small" className='MuiButtonBase-root MuiFab-sizeSmall mr-2' href={"model/"+version_id} >
                    <EditIcon fontSize="small" /> 
                  </Fab>
                  <Fab color="secondary" aria-label="edit" variant="extended" style={{boxShadow: 'none' }} fontSize="small" className='MuiButtonBase-root MuiFab-sizeSmall mr-2' href={"model/"+version_id+"/1"}>
                    <ViewIcon fontSize="small" /> 
                  </Fab>
                  <Fab color="primary" aria-label="view" variant="extended" style={{boxShadow: 'none' }} fontSize="small" className='MuiButtonBase-root MuiFab-sizeSmall mr-2'  onClick={(e)=> {this.handleDelete(e, version_id)}}>
                    <DeleteIcon fontSize="small" /> 
                  </Fab>
                </div>
                  )}
            }
     }
    ];


  const options = {
    print:false,
    responsive: 'stacked',
    selectableRowsOnClick: true,
    onDownload: () => {
      this.setState({backdrop: true})
      this.handleDownload()
      return false
    },
    rowsPerPage: 10,
      customToolbar: () => {
        return (
          <CustomToolbar url="new" />
        );
      },
    textLabels: {
          toolbar: {
            search: "Buscar",
            viewColumns: "Ver columnas",
            filterTable: "Filtros",   
            downloadCsv: "Exportar XLS",
          },
          body: {
              noMatch: this.state.isLoaded ?
                  'No hay resultados' :
                  <CircularProgress />,
          },
          selectedRows: {
            text: "fila(s) seleccionadas"
          },
          viewColumns: {
            title: "Ver columnas",
          },
          pagination: {
            next: "Siguiente",
            previous: "Anteior",
            rowsPerPage: "Cantidad por página:",
            displayRows: "de",      
          },
          filter: {
            all: "Todos",
            title: "Filtros",
            reset: "Limpiar"
          }
      }
  };

   return(
      <Container fluid className="main-content-container px-4">
          <Row>
            <Col className="p-2">
              <div>
               <Dialog
                  open={this.state.dialogOpen}
                  onClose={(e)=>this.handleDialogClose(e)}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                <DialogTitle id="alert-dialog-title">Dar de baja!</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                      {this.state.message}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  {(!this.state.errors)?
                    (
                    (this.state.delete_id ==='')?
                      <div>
                        <Button onClick={(e)=>this.handleRefresh(e)} color="primary" >
                          Continuar
                        </Button>
                      </div>
                    :
                    <div>
                    <Button onClick={(e)=>this.handleDialogClose(e)} color="primary" autoFocus>
                      Cancelar
                    </Button>
                    <Button onClick={this.confirmDelete.bind(this)} color="primary" >
                      Continuar
                    </Button>
                    </div>
                   )
                  :(
                  <div>
                  <Button onClick={(e)=>this.handleDialogClose(e)} color="primary" >
                    Continuar
                  </Button>
                  </div>
                  )}
                </DialogActions>
              </Dialog> 
              </div>            
              <div>
              <Backdrop open={this.state.backdrop} onClick={this.handleCloseBackdrop} style={{zIndex: 10000, color: '#3f51b5'}}>
                <CircularProgress color="inherit" /> <Typography className="ml-2" variant="h5" color="primary">Descargando...</Typography>
              </Backdrop>
               <MuiThemeProvider theme={this.getMuiTheme()}>
                <MUIDataTable
                  title="Lista de Modelos"
                  data={Object.values(this.state.models)}
                  columns={columns}
                  options={options}
                 />
                 <div style={{textAlign: "right"}}>
                   <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/contracts"}>
                      Volver
                  </Button>
                </div>
              </MuiThemeProvider>
              </div>
            </Col>
          </Row>
         </Container>
    );
  }

}

export default Models;   